import { render, staticRenderFns } from "./RolePermissionsView.vue?vue&type=template&id=1c3cc1b9&"
import script from "./RolePermissionsView.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsView.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsView.vue?vue&type=style&index=0&id=1c3cc1b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports